module.exports = __webpack_public_path__ + "img/ae-icon.26857839.svg";